import { useState } from 'react';
import { exportUtils } from '../utils/exportUtils';

export const useExport = (defaultFileName = 'export', defaultTitle = 'Report') => {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async (format, data, columns, customFileName, customTitle) => {
    if (!data || data.length === 0) {
      console.warn('No data to export');
      return false;
    }

    setIsExporting(true);
    
    try {
      const fileName = customFileName || defaultFileName;
      const title = customTitle || defaultTitle;
      
      let success = false;
      
      switch (format) {
        case 'csv':
          success = exportUtils.toCSV(data, columns, fileName);
          break;
        case 'excel':
          success = exportUtils.toExcel(data, columns, fileName);
          break;
        case 'pdf':
          success = exportUtils.toPDF(data, columns, fileName, title);
          break;
        default:
          console.error('Unsupported export format:', format);
      }
      
      return success;
    } catch (error) {
      console.error('Export failed:', error);
      return false;
    } finally {
      setIsExporting(false);
    }
  };

  return {
    isExporting,
    handleExport
  };
};